import React from 'react';
import './Clientes-Modal.css';
import SeminarioMayormp4 from './assets/Seminario_Mayor/SeminarioMayor.mp4';
import sem_ma from './assets/Seminario_Mayor/Sem_Ma.mp4';

const SeminarioMayor = () => {
  return (
    <div className="container">
      <h2>✅ Proyecto: Seminario Mayor Santo Tomás de Aquino🌞✨</h2>

      <video controls>
        <source src={SeminarioMayormp4} type="video/mp4" />
        Tu navegador no soporta la reproducción de video.
      </video>
      <p>

<span className="highlight">Energía limpia al servicio de una misión espiritual: sostenibilidad que acompaña la formación sacerdotal.</span>

<br/><br/>En el Seminario Mayor Santo Tomás de Aquino <span className="highlight"> institución donde se forman los futuros sacerdotes de la región y un referente espiritual para la diócesis</span> instalamos un sistema solar fotovoltaico conectado a la red con una capacidad de 19.95 kWp, compuesto por 30 paneles solares de alta eficiencia y un inversor multicanal de 20 kW.

<br/><br/>Esta tecnología permite distribuir y gestionar de forma estable la energía producida, asegurando un funcionamiento óptimo para las actividades cotidianas de estudio, formación y vida comunitaria.

<br/><br/>Los objetivos de este proyecto fueron:

<br/><br/>✔ Reducir los costos asociados al consumo eléctrico del seminario.
<br/>✔ Implementar una solución sostenible y coherente con el cuidado de la creación.
<br/>✔ Garantizar energía constante para iluminación, equipos y espacios de uso comunitario.

<br/><br/>Hoy, el Seminario Mayor genera su propia energía limpia, disminuyendo los costos mensuales de facturación eléctrica y destinando esos recursos al fortalecimiento de la formación espiritual y académica de sus seminaristas.

<br/>Con esta instalación, la institución refuerza su compromiso no solo con la fe, sino también con la protección del planeta, convirtiéndose en un modelo de sostenibilidad para la comunidad.

<br/><br/><span className="highlight">Este proyecto cuenta con el acompañamiento de IPSUM Ingeniería e Innovación, ofreciendo:</span>

<br/><br/>🔧 Soporte técnico y mantenimiento preventivo.
<br/>🔧 Monitoreo del sistema para garantizar máxima eficiencia energética.
<br/>🔧 Instalación estructural segura y diseñada para prolongar la vida útil del sistema y facilitar el proceso de mantenimiento.
<br/>🔧 Capacitación al usuario en el manejo de la aplicación de monitoreo.
<br/>🔧 Acompañamiento presencial de nuestros ingenieros durante y después de la instalación.

<span className="highlight"><br/><br/>Una decisión inteligente que une sostenibilidad, ahorro y propósito espiritual.</span>
<br/>
<br/>
 <div className="video-responsive">
        <iframe
          src="https://www.youtube.com/embed/nL-gf_fU8to"
          title="Testimmonio Palacio Arzobispal"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>

      </p>
      <video controls>
        <source src={sem_ma} type="video/mp4" />
        Tu navegador no soporta la reproducción de video.
      </video>
    </div>
  );
};

export default SeminarioMayor;
